import React, { useState } from "react";

const Switch = ({ options, setOption }) => {
  // Estado para la posición del switch
  const [isLeft, setIsLeft] = useState(true);

  const toggleSwitch = () => {
    const selectedOption = isLeft ? options[1] : options[0];
    setOption(selectedOption.value);
    setIsLeft(!isLeft);
  };

  return (
    <div className="flex items-center space-x-2">
      {/* Etiqueta izquierda */}
      <span
        className={`text-sm ${
          isLeft ? "text-black font-bold" : "text-gray-500"
        }`}
      >
        {options[0].text}
      </span>

      {/* Switch */}
      <div
        onClick={toggleSwitch}
        className={`relative w-16 h-8 rounded-full cursor-pointer transition-colors ${
          isLeft ? "bg-accent-green" : "bg-light-purple-600"
        }`}
      >
        <div
          className={`absolute top-1 left-1 w-6 h-6 bg-white rounded-full shadow-md transition-transform ${
            isLeft ? "transform translate-x-0" : "transform translate-x-8"
          }`}
        ></div>
      </div>

      {/* Etiqueta derecha */}
      <span
        className={`text-sm ${
          !isLeft ? "text-black font-bold" : "text-gray-500"
        }`}
      >
        {options[1].text}
      </span>
    </div>
  );
};

export default Switch;
